import React from 'react'
import PropTypes from 'prop-types'
import { Avatar } from '@ticketswap/solar'
import { useViewer } from '~/components/ViewerContext'

const ListingAvatar = ({ image }) => {
  const { deviceInfo } = useViewer()
  const { isMobile } = deviceInfo

  return <Avatar size={isMobile ? 32 : 40} src={image} />
}

ListingAvatar.propTypes = {
  image: PropTypes.string,
}

export default ListingAvatar
